<template>
    <footer>
        &copy;{{ year }} Gulf of Maine Research Institute
        <span class="space" aria-hidden="true"></span>
        <a href="https://www.gmri.org/privacy-terms/" target="_blank" >Privacy Policy</a>
    </footer>
</template>


<script>
export default {
    name: 'Footer',
    computed: {
        year: () => new Date().getFullYear()
    },
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

footer {
    bottom: $s1;
    color: $color-gray;
    font-size: $font-size-small;
    left: $s3;              
    position: fixed;
    z-index: 9001;

    a {
        color: $color-gray;
    }

    .space {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}
</style>
